// extracted by mini-css-extract-plugin
module.exports = {"icon":"ContactInfo_icon__CMgKa"};